@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  body {
    @apply bg-slate-50 text-gray-900 antialiased;
  }
}

@layer components {
  /* ── Buttons ─────────────────────────────────────────────── */
  .btn {
    @apply inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium
           transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2;
  }
  .btn-primary {
    @apply btn bg-ocean-700 text-white hover:bg-ocean-800 focus:ring-ocean-500;
  }
  .btn-secondary {
    @apply btn bg-white text-gray-700 border border-gray-300 hover:bg-ocean-50 focus:ring-ocean-500;
  }
  .btn-danger {
    @apply btn bg-coral-500 text-white hover:bg-coral-600 focus:ring-coral-400;
  }
  .btn-ghost {
    @apply btn text-gray-600 hover:bg-ocean-50 focus:ring-ocean-400;
  }

  /* ── Cards ───────────────────────────────────────────────── */
  .card {
    @apply bg-white rounded-xl shadow-sm border border-ocean-100 p-4;
  }
  .card-ocean {
    @apply rounded-xl shadow-sm border border-ocean-200 p-4 bg-ocean-card;
  }

  /* ── Form ────────────────────────────────────────────────── */
  .badge {
    @apply inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium;
  }
  .input {
    @apply block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm
           shadow-sm placeholder-gray-400
           focus:border-ocean-500 focus:outline-none focus:ring-1 focus:ring-ocean-500;
  }
  .label {
    @apply block text-sm font-medium text-gray-700 mb-1;
  }

  /* ── Dive-Computer Zahlen ─────────────────────────────────── */
  .dive-value {
    @apply font-mono text-ocean-700 font-semibold tabular-nums;
  }

  /* ── Bubble Spinner ──────────────────────────────────────── */
  .bubble-spinner {
    @apply relative flex items-end justify-center gap-1.5 h-8;
  }
  .bubble-spinner span {
    @apply block rounded-full bg-ocean-400 w-2.5 h-2.5;
  }
  .bubble-spinner span:nth-child(1) { @apply animate-bubble-1; }
  .bubble-spinner span:nth-child(2) { @apply animate-bubble-2; }
  .bubble-spinner span:nth-child(3) { @apply animate-bubble-3; }
}
